import { SettingsKeys } from '../../api/models/TranslationKeys';
import { CmsProperty } from '../../api/models/Shared.types';
import { Theme } from '../../config/theme';
import { CmsTabbedRibbon } from '../../components/cms/CmsTabbedRibbon';
import { RecordingRibbonDataSource } from './RecordingRibbonDataSource';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { CardSizeInfo } from './CardSizeInfo';
import { TabbedDs } from './TabbedEpgEpisodesRibbonDataSource';
import { Recording } from '../../api/user/RecordingApi.types';

export interface RecordingSeasons {
  recordings: Recording[];
  seasonId: string;
  title: string;
}

/**
 * @property {Backend} backend
 * @property {DataSource[]} dataSources
 */
export class TabbedRecordingRibbonDataSource {
  private backend: Backend;
  private seasons: RecordingSeasons[];
  private title: string;
  private channels: ChannelModel[];
  private buttonHeight: number;
  private sizeInfo: CardSizeInfo | undefined;
  private seasonRibbons: TabbedDs[] | undefined;
  /**
   * @param {Backend} backend
   * @param seasons
   * @param title
   * @param channels
   * @param [buttonHeight]
   */
  constructor(
    backend: Backend,
    seasons: RecordingSeasons[],
    title: string,
    channels: ChannelModel[],
    buttonHeight = 58
  ) {
    this.backend = backend;
    this.seasons = seasons;
    this.title = title;
    this.channels = channels;
    this.buttonHeight = buttonHeight;

    this.sizeInfo = undefined;
  }

  /**
   * @returns {Promise<*>}
   */
  load() {
    return Promise.resolve().then(() => {
      this.seasonRibbons = [];
      if (this.seasons.length > 0) {
        let properties = this.backend.globalSettings.stringArray(SettingsKeys.propertiesRecordingEpisodesRibbon);
        properties = properties
          ? properties
          : [
              CmsProperty.ShowProgress,
              CmsProperty.ShowScheduleInfo,
              CmsProperty.UseBestSchedule,
              CmsProperty.ShowEpisodeInfo,
            ];

        this.seasonRibbons = this.seasons.map(season => {
          return {
            dataSource: new RecordingRibbonDataSource(this.backend, season.recordings, properties!, this.channels),
            title: season.title,
          };
        });
        if (this.seasonRibbons && this.seasonRibbons[0]) {
          //calculate first ribbon for height
          return this.seasonRibbons[0].dataSource.loadNext().then(() => {
            this.seasonRibbons![0]!.dataSource.loadedIdx = 0;
            this.sizeInfo = this.seasonRibbons![0]!.dataSource.sizeInfo;
            return this.seasonRibbons;
          });
        }
      }
    });
  }

  isEmpty(): boolean {
    return !this.seasons || this.seasons.length === 0;
  }

  noData(): boolean {
    return !this.seasons || this.seasons.length === 0;
  }

  totalHeight(): number {
    return Theme.Fonts.Ribbon.Title.lineHeight + this.buttonHeight + (this.sizeInfo ? this.sizeInfo.height : 0);
  }

  componentDescription() {
    return {
      focusable: true,
      type: CmsTabbedRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
